<template>
  <div id="content">
    <div class="header col-md-12">
      <div class="header-inner row align-items-center">
        <div class="col-8 left">
          <div class="title">
            {{ $t('sidebar.products') }}
            <template v-if="ready">
              >
              {{ product.product_name }}
            </template>
          </div>
        </div>
        <div class="col-4 right">
          <div
            v-if="ready"
            class="action">
            <div
              v-if="showOptionButton"
              class="dropdown item">
              <button
                class="btn no-bg dropdown-toggle text-secondary shake"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false">
                <i class="fas fa-cog"/>
                <span class="name">{{ $t('button.options') }}</span>
              </button>
              <div class="dropdown-menu dropdown-menu-right">
                <a
                  v-if="hasRoleDelete"
                  class="dropdown-item"
                  @click="openConfirmdeleteModal()">
                  <i class="fas fa-trash text-danger"/>
                  <span class="text-danger">{{ $t('button.delete') }}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content col-md-12">
      <p v-if="!ready">{{ $t('message.loading') }}</p>

      <template v-if="ready">
        <section class="choose-type">
          <div class="col-md-12 no-padding">
            <section-header :title="$t('message.selecttype')"/>
            <div class="row wrapper">
              <div class="col-md-6">
                <div class="col-12 row no-margin no-padding">
                  <vs-radio
                    v-model="form.typeRadios"
                    :disabled="true"
                    color="#A3CA76"
                    vsValue="product"
                    style="float: left;padding: 0;">
                    <strong>{{ $t('message.product') }}</strong>
                  </vs-radio>
                </div>
                <div
                  class="form-check-label"
                  style="margin-left: 25px;">
                  <p>{{ $t('message.selecttype_detail1') }}</p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="col-12 row no-margin no-padding">
                  <vs-radio
                    v-model="form.typeRadios"
                    :disabled="true"
                    color="#A3CA76"
                    vsValue="service"
                    style="float: left;padding: 0;">
                    <strong>{{ $t('message.service') }}</strong>
                  </vs-radio>
                </div>
                <div
                  class="form-check-label"
                  style="margin-left: 25px;">
                  <p>{{ $t('message.selecttype_detail2') }}</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div class="section-product">
          <section class="mb-1">
            <div class="col-md-12 no-padding">
              <section-header :title="$t('message.general')"/>
              <div class="form-row">
                <div class="col-md-12">
                  <div class="form-group row">
                    <div class="col-md-4">
                      <label>{{ $t('message.productimage') }}</label>
                      <div class="row">
                        <div class="col-12">
                          <template v-if="disabledForm">
                            <img
                              v-if="product.images.original"
                              :src="product.images.original"
                              class="col-12 no-padding"
                              style="max-width: 200px;">
                            <img
                              v-else
                              :src="defaultImages.product"
                              class="col-12 no-padding"
                              style="max-width: 200px;">
                          </template>
                          <template v-else>
                            <file-pond
                              v-if="form.isShowFilePond == true"
                              ref="pond"
                              :server="{process, revert, restore, load, fetch}"
                              name="file"
                              className="my-pond"
                              acceptedFileTypes="image/jpeg, image/png"
                              imagePreviewHeight="240"
                              imageCropAspectRatio="1:1"
                              labelIdle="อัพโหลดรูปภาพ"
                              labelTapToUndo=""
                              labelTapToCancel="คลิกเพื่อยกเลิก"
                              labelFileProcessing="กำลังอัปโหลด"
                              labelFileLoading="กำลังโหลด"
                              labelFileProcessingComplete=""
                              labelButtonRemoveItem="นำออก"
                              labelFileProcessingError="เกิดข้อผิดพลาด"
                              labelButtonAbortItemProcessing="ยกเลิก"
                              @init="handleFilePondInit"/>
                            <div
                              v-else
                              style="width: 200px;position: relative;">
                              <template>
                                <img
                                  v-if="product.images.original"
                                  :src="product.images.original"
                                  class="col-12 no-padding"
                                  style="max-width: 200px;">
                                <img
                                  v-else
                                  :src="defaultImages.product"
                                  class="col-12 no-padding"
                                  style="max-width: 200px;">
                              </template>
                              <div style="width: 100%; position: absolute; top: 5px; left: 0px; text-align: right;">
                                <button
                                  class="btn btn-sm btn-close-image"
                                  @click="closeImage()">
                                  <i class="fas fa-times"/>
                                </button>
                              </div>
                            </div>
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="col-md-12">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <label>{{ $t('message.productname') }} *</label>
                      <input
                        v-model="form.productName"
                        :class="[{'is-invalid': isDuplicatedProductName()}]"
                        :disabled="disabledForm"
                        type="text"
                        class="form-control">
                      <div
                        v-if="isDuplicatedProductName()"
                        class="invalid-feedback">
                        {{ $t('message.namecannotbeduplicated') }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="col-md-6">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <label>{{ $t('message.category') }}</label>
                      <selectize
                        :options="form.optionsCat"
                        v-model="form.catName"
                        :default="form.defaultCatName"
                        :multiple="false"
                        :create="true"
                        :placeholder="$t('placeholder.selectorcreate')"
                        :disabled="disabledForm"
                        @change="onChangedCat()"/>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <label>{{ $t('message.unit') }}</label>
                      <selectize
                        :options="form.optionsUnit"
                        v-model="form.unit"
                        :default="form.defaultUnit"
                        :multiple="false"
                        :create="true"
                        :placeholder="$t('placeholder.selectorcreate')"
                        :disabled="disabledForm"
                        @change="onChangedUnit()"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section>
            <div class="col-md-12 no-padding">
              <section-header :title="$t('message.pricing')"/>
              <div class="form-row">
                <template v-if="form.prices.length == 0">
                  <div class="col-md-6">
                    <div class="form-group row">
                      <div class="col-md-12">
                        <label>{{ $t('message.price') }}</label>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <button
                              :disabled="disabledForm"
                              class="btn dropdown-toggle"
                              type="button"
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                              style="border: 1px solid #ced4da;">
                              <template v-if="form.isFixedPrice">
                                {{ $t('message.fixedprice') }}
                              </template>
                              <template v-if="!form.isFixedPrice">
                                {{ $t('message.variableprice') }}
                              </template>
                            </button>
                            <div class="dropdown-menu">
                              <a
                                class="dropdown-item"
                                @click="form.isFixedPrice = true">{{ $t('message.fixedprice') }}</a>
                              <a
                                class="dropdown-item"
                                @click="form.isFixedPrice = false">{{ $t('message.variableprice') }}</a>
                            </div>
                          </div>
                          <input
                            :disabled="!form.isFixedPrice || disabledForm"
                            v-model="form.textField_ProductPrice"
                            type="text"
                            class="form-control text-right text-select-all"
                            @keypress="numberOnly"
                            @keyup="form.textField_ProductPrice = setToValidNumber(form.textField_ProductPrice)"
                            @blur="form.textField_ProductPrice = setToCustomDigitsNumber(form.textField_ProductPrice)">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group row">
                      <div class="col-md-12">
                        <label>{{ $t('message.cost') }}</label>
                        <input
                          v-model="form.textField_ProductCost"
                          :disabled="disabledForm"
                          type="text"
                          class="form-control text-right text-select-all"
                          @keypress="numberOnly"
                          @keyup="form.textField_ProductCost = setToValidNumber(form.textField_ProductCost)"
                          @blur="form.textField_ProductCost = setToCustomDigitsNumber(form.textField_ProductCost)">
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group row">
                      <div class="col-md-12">
                        <label>{{ $t('message.barcode') }}</label>
                        <input
                          v-model="form.barcode"
                          :disabled="disabledForm"
                          type="text"
                          class="form-control text-select-all">
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group form-row">
                      <div class="col-md-6">
                        <div class="form-group row">
                          <div class="col-md-12">
                            <label>{{ $t('message.sku') }}</label>
                            <input
                              v-model="form.stock.sku"
                              :disabled="disabledForm"
                              type="text"
                              class="form-control">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <div class="col-md-12 mt-1">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <template>
                        <button
                          v-if="form.prices.length > 0"
                          class="btn btn-light"
                          @click="openModalPrices()">
                          {{ $t('message.addprices', {number: form.prices.length}) }}
                        </button>
                        <button
                          v-else
                          :disabled="disabledForm"
                          class="btn btn-light"
                          @click="openModalPrices()">
                          {{ $t('message.addmoreprices') }}
                        </button>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        <div
          v-if="form.chooseType == 'service'"
          class="section-service">
          <section>
            <div class="col-md-12 no-padding">
              <section-header :title="$t('message.service')"/>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <label>{{ $t('message.servicename') }} *</label>
                      <input
                        v-model="form.productName"
                        :disabled="disabledForm"
                        type="text"
                        class="form-control">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section>
            <div class="col-md-12 no-padding">
              <section-header :title="$t('message.pricing')"/>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <label>{{ $t('message.price') }}</label>
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <button
                            :disabled="disabledForm"
                            class="btn dropdown-toggle"
                            type="button"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                            style="border: 1px solid #ced4da;">
                            <template v-if="form.isFixedPrice">
                              {{ $t('message.fixedprice') }}
                            </template>
                            <template v-if="!form.isFixedPrice">
                              {{ $t('message.variableprice') }}
                            </template>
                          </button>
                          <div class="dropdown-menu">
                            <a
                              class="dropdown-item"
                              @click="form.isFixedPrice = true;form.textField_ServicePrice = 0">{{ $t('message.fixedprice') }}</a>
                            <a
                              class="dropdown-item"
                              @click="form.isFixedPrice = false">{{ $t('message.variableprice') }}</a>
                          </div>
                        </div>
                        <input
                          :disabled="!form.isFixedPrice || disabledForm"
                          v-model="form.textField_ServicePrice"
                          type="text"
                          class="form-control text-right text-select-all"
                          @keypress="numberOnly"
                          @keyup="form.textField_ServicePrice = setToValidNumber(form.textField_ServicePrice)"
                          @blur="form.textField_ServicePrice = setToCustomDigitsNumber(form.textField_ServicePrice)">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <label>{{ $t('message.cost') }}</label>
                      <input
                        v-model="form.textField_ServiceCost"
                        :disabled="disabledForm"
                        type="text"
                        class="form-control text-right text-select-all"
                        @keypress="numberOnly"
                        @keyup="form.textField_ServiceCost = setToValidNumber(form.textField_ServiceCost)"
                        @blur="form.textField_ServiceCost = setToCustomDigitsNumber(form.textField_ServiceCost)">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        <section
          v-if="!disabledForm"
          class="action-bar">
          <template>
            <div
              v-if="!$store.state.app.loading"
              class="col-md-12 text-right">
              <button
                :disabled="disabled.btn_update"
                class="btn btn-web"
                @click="update()">{{ $t('button.save') }}</button>
            </div>
            <div
              v-else
              class="col-md-12 text-right">
              <!-- <button class="btn btn-light btn-block-mobile-only" disabled>{{ $t('button.cancel') }}</button> -->
              <button
                class="btn btn-web btn-block-mobile-only"
                disabled><i class="fas fa-spinner spin"/></button>
            </div>
          </template>
        </section>
      </template>

    </div>

    <div
      id="pricesModal"
      class="modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="pricesModalTitle"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static">
      <div
        class="modal-dialog modal-lg"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5
              id="pricesModalTitle"
              class="modal-title">{{ $t('message.addmoreprices') }}</h5>
            <button
              type="button"
              class="close"
              aria-label="Close"
              @click="cancelPrices()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <attribute
              v-if="form.isShowModalPrices"
              :trickReset="form.trickResetAttribute"
              :validation="form.trickValidationAttribute"
              :data="form.attributes"
              :defaultPrices="form.defaultPrices"
              :disabled="disabledForm"
              page="edit"
              @data="submitForm"
            />
          </div>
          <div class="modal-footer">
            <button
              v-if="!disabledForm"
              type="button"
              class="btn btn-light"
              @click="cancelPrices()">{{ $t('button.cancel') }}</button>
            <button
              v-if="!disabledForm"
              type="button"
              class="btn btn-light"
              @click="resetPrices()">{{ $t('button.reset') }}</button>
            <button
              type="button"
              class="btn btn-web"
              @click="applyPrices()">{{ $t('button.apply') }}</button>
          </div>
        </div>
      </div>
    </div>

    <div
      id="confirmdeleteModal"
      class="modal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static">
      <div
        class="modal-dialog "
        role="document">
        <div class="modal-content">
          <div
            class="modal-header"
            style="border-bottom: none;">
            <h5 class="modal-title">
              {{ $t('message.areyousuretodeletethis') }}
            </h5>
            <button
              v-if="!$store.state.app.loading"
              type="button"
              class="close"
              aria-label="Close"
              @click="closeConfirmdeleteModal()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div
            v-if="!$store.state.app.loading"
            class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              @click="closeConfirmdeleteModal()">{{ $t('button.cancel') }}</button>
            <button
              type="button"
              class="btn btn-danger"
              @click="del()">{{ $t('button.delete') }}</button>
          </div>
          <div
            v-if="$store.state.app.loading"
            class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              disabled>{{ $t('button.cancel') }}</button>
            <button
              type="button"
              class="btn btn-danger"
              disabled>
              <i class="fas fa-spinner spin"/>
            </button>
          </div>
        </div>
      </div>
    </div>

    <BaseConfirmDiscardModal
      :show="confirmDiscardModal.show"
      @onCancel="handleDiscardCancleModal"
      @onConfirm="handleDiscardConfirmModal"
    />

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import sidebarModule from './../../sidebarModule'
import _ from 'lodash'
import discardFormMixin from '@/mixins/discardForm'
import userPermissionMixin from '@/mixins/userPermission'

// Import Vue FilePond
import vueFilePond from 'vue-filepond'

// Import FilePond styles
import 'filepond/dist/filepond.min.css'

// Import FilePond plugins
// Please note that you need to install these plugins separately

// Import image preview plugin styles
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css'

// Import image preview and file type validation plugins
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import FilePondPluginImageCrop from 'filepond-plugin-image-crop'
import FilePondPluginImageResize from 'filepond-plugin-image-resize'
import FilePondPluginImageTransform from 'filepond-plugin-image-transform'

// Create component
const FilePond = vueFilePond(FilePondPluginFileValidateType,
  FilePondPluginImagePreview,
  FilePondPluginFileValidateSize,
  FilePondPluginImageCrop,
  FilePondPluginImageResize,
  FilePondPluginImageTransform)

export default {
  name: 'ProductNew',
  components: {
    FilePond,
  },
  mixins: [discardFormMixin, userPermissionMixin],
  data () {
    return {
      ready: false,

      form: {
        typeRadios: 'product',
        chooseType: 'product', // default
        formEdited: false,
        productName: null,

        textField_ProductPrice: 0,
        textField_ProductCost: null,
        isFixedPrice: true,

        textField_ServicePrice: 0,
        textField_ServiceCost: null,

        barcode: null,

        stock: {
          sku: '',
        },

        brandName: null,
        catName: null,
        defaultCatName: null,
        unit: null,
        defaultUnit: null,

        tempPrices: [],
        tempAttrs: [],

        optionsBrand: [{
          value: 'opt1',
          text: 'opt1',
        }, {
          value: 'opt2',
          text: 'opt2',
        }],
        optionsCat: [],
        optionsUnit: [],

        trickResetAttribute: 0,
        trickValidationAttribute: 0,
        attributes: [],
        prices: [],
        defaultPrices: null,
        images: [{
          type: 'original',
          location: null,
        }, {
          type: 'thumbnail',
          location: null,
        }],

        isShowModalPrices: false,
        isShowFilePond: false,
      },

      originalForm: null,

      disabled: {
        btn_update: false,
      },

      isSubmitted: false,
    }
  },
  computed: {
    ...mapGetters({
      sidebar: 'getSidebar',
      categories: 'getCategories',
      units: 'getUnits',
      nextSkucode: 'getNextSkuCode',
      allSkuCode: 'getAllSkuCode',
      product: 'getProduct',
      defaultImages: 'getDefaultImages',
      getUserCanEdit: 'getUserCanEdit',
      getUserCanUpdateStatus: 'getUserCanUpdateStatus',
      getNames: 'getNames',
    }),
    disabledForm () {
      return !this.hasRoleEdit
    },
  },
  watch: {
    ready: function () {
      // loading finish
      this.showFinish(this.$Progress)
    },
    'form.productName': {
      handler: function (after) {
        this.form.formEdited = true
      },
      deep: true,
    },
    'form.typeRadios': {
      handler: function (newVal) {
        // chanage chooseType
        this.form.chooseType = newVal
      },
      deep: true,
    },
    'categories': {
      handler: function (newVal) {
        this.form.optionsCat = []
        let items = newVal
        for (let i in items) {
          this.form.optionsCat.push({
            text: items[i].category_name,
            value: items[i].category_name,
          })
        }
      },
      deep: true,
    },
    'units': {
      handler: function (newVal) {
        this.form.optionsUnit = []
        let items = newVal
        for (let i in items) {
          this.form.optionsUnit.push({
            text: items[i].name,
            value: items[i].name,
          })
        }
      },
      deep: true,
    },
    'form.isFixedPrice': {
      handler: function (after) {
        if (!after) {
          this.form.textField_ProductPrice = null
          this.form.textField_ServicePrice = null
        }
      },
      deep: true,
    },
  },
  beforeCreate: function () {

  },
  created: async function () {
    /**
     *  validation
     */
    if (!this.$route.query.pid) {
      return this.$router.push({ name: 'ProductAll' })
    }
    // get category
    let res = await this.$store.dispatch('getProduct', {
      product_id: this.$route.query.pid,
    })
    if (!res.success) {
      return this.$router.push({ name: 'ProductAll' })
    }
    if (res.data.length == 0) {
      return this.$router.push({ name: 'ProductAll' })
    }
    /**
     *  validation success
     */
    await Promise.all([
      this.$store.dispatch('getCategories'),
      this.$store.dispatch('getUnits'),
      this.$store.dispatch('getNextSkuCode'),
      this.$store.dispatch('getAllSkuCode'),
      this.$store.dispatch('getAllSkuAttributes'),
      this.$store.dispatch('getNames'),
    ])

    // set data
    this.setData()
    // set ready
    this.ready = true
  },
  beforeMount: function () {
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.products.title'),
      current: {
        app_name: 'products',
        app_id: 2,
        module_id: 1,
      },
    })
    // set sidebar ui
    sidebarModule.init(this.getObject(require('../sidebar.json')))
    sidebarModule.update(this.sidebar, 0, [{
      'name': this.$route.query.pname,
      'router': {
        'name': 'ProductEdit',
        'query': {
          pid: this.$route.query.pid,
          pname: this.$route.query.pname,
        },
      },
      'activeClass': 'active',
    }], {
      sidebarAtIdx: 0,
      submenuAtIdx: 2,
    })
  },
  mounted: function () {
    // set popup modal
    this.setModal('#pricesModal')
    this.setModal('#confirmdeleteModal')
  },
  updated: function () {

  },
  destroyed: function () {
    this.leavePage(this.$Progress, ['clearCategories'])
  },
  methods: {
    cancelPrices () {
      let that = this
      let __ = _

      if (this.form.prices.length > 0) {
        this.form.prices = _.cloneDeep(this.form.tempPrices)
        this.form.attributes = []
        setTimeout(() => {
          that.form.attributes = _.cloneDeep(this.form.tempAttrs)
        }, 1)
      }

      that.closeModalPrices()
    },
    resetPrices () {
      this.form.trickResetAttribute++
    },
    applyPrices () {
      this.form.trickValidationAttribute++
    },
    async clearForm () {
      let that = this

      this.ready = false

      this.checkToDeleteS3Images()

      this.form = _.cloneDeep(this.originalForm)

      setTimeout(() => {
        that.ready = true
        // scroll to top
        $('html, body').animate({ scrollTop: 0 }, 'slow')
      }, 100)
    },
    /*
     *  this function response when trickValidationAttribute is chanaged, <attribute></attribute> component
     */
    submitForm (isValid, data) {
      if (!isValid) {
        return false
      }

      this.form.prices = data

      if (this.form.prices.length > 0) {
        this.form.tempPrices = _.cloneDeep(this.form.prices)
        this.form.defaultPrices = _.cloneDeep(this.form.prices)
        this.form.tempAttrs = _.cloneDeep(this.form.attributes)
      } else {
        this.form.tempPrices = []
        this.form.defaultPrices = []
        this.form.tempAttrs = []
      }

      this.closeModalPrices()
    },
    async update () {
      const isValid = !this.isDuplicatedProductName()
      if (!isValid) {
        // scroll to top
        $('html, body').animate({ scrollTop: 0 }, 'slow')
        return false
      }

      this.isSubmitted = true

      let dataSet = {}

      dataSet['product_id'] = this.product.product_id

      if (this.form.productName) dataSet['product_name'] = this.form.productName
      if (this.form.typeRadios) dataSet['type'] = this.form.typeRadios
      if (this.form.typeRadios == 'service') {
        dataSet['prices'] = {
          'insert': [],
          'update': [{
            price: this.form.textField_ServicePrice,
            cost: this.form.textField_ServiceCost,
            sku_id: this.product.prices[0].sku_id,
          }],
          'delete': [],
        }
      } else if (this.form.typeRadios == 'product') {
        if (this.form.prices.length == 0) {
          if (this.product.prices.length == 1) {
            dataSet['prices'] = {
              'insert': [],
              'update': [{
                price: this.form.textField_ProductPrice,
                cost: this.form.textField_ProductCost,
                sku_id: this.product.prices[0].sku_id,
                barcode: this.form.barcode,
                sku: this.form.stock.sku,
              }],
              'delete': [],
            }
          } else {
            let skus = this.getPrices(this.form.prices, this.product.prices)
            dataSet['prices'] = {
              'insert': [{
                price: this.form.textField_ProductPrice,
                cost: this.form.textField_ProductCost,
              }],
              'update': [],
              'delete': this.getDeleteSkus(this.getUpdateSkus(skus), this.product.prices),
            }
          }
        } else {
          let skus = this.getPrices(this.form.prices, this.product.prices)
          dataSet['prices'] = {
            'insert': this.getInsertSkuds(skus),
            'update': this.getUpdateSkus(skus),
            'delete': this.getDeleteSkus(this.getUpdateSkus(skus), this.product.prices),
          }
        }
      }

      if (this.form.catName) dataSet['category_name'] = this.form.catName
      if (this.form.unit) dataSet['unit'] = this.form.unit

      if (this.form.images) {
        var images = {}
        this.form.images.map(img => {
          images[img.type] = img.location
        })
        dataSet['images'] = images
      }

      this.clean_dataSet(dataSet)

      let res = await this.$store.dispatch('updateProduct', dataSet)

      if (res.success) {
        await Promise.all([
          this.$store.dispatch('getProduct', {
            product_id: this.product.product_id,
          }),
          this.$store.dispatch('getAllSkuCode'),
          this.$store.dispatch('getNames'),
        ])
        // show notify
        this.notify(this.$vs, {
          text: this.$t('message.hasbeenupdated', { msg: this.form.productName }),
          color: 'success',
          icon: 'cloud',
        })
        // set data
        this.setData()
        this.isSubmitted = false
        // loading finish
        this.showFinish(this.$Progress)
        // scroll to top
        $('html, body').animate({ scrollTop: 0 }, 'slow')
      }
    },
    clean_dataSet (dataSet) {
      function cleanPrices (prices) {
        prices.map(p => {
          if (typeof p.price === 'string') {
            if (p.price.trim() == '') {
              p.price = 0
            } else {
              p.price = parseFloat(p.price)
            }
          }
          if (typeof p.cost === 'string') {
            if (p.cost.trim() == '') {
              p.cost = null
            } else {
              p.cost = parseFloat(p.cost)
            }
          }
          if (typeof p.barcode === 'string') {
            if (p.barcode.trim() == '') {
              p.barcode = null
            }
          }
          if (typeof p.sku === 'string') {
            if (p.sku.trim() == '') {
              p.sku = null
            }
          }
          if (p.is_fixedprice !== undefined) {
            delete p.is_fixedprice
          }
          if (p.is_custom_sku !== undefined) {
            delete p.is_custom_sku
          }
        })
      }
      cleanPrices(dataSet.prices.insert)
      cleanPrices(dataSet.prices.update)
      cleanPrices(dataSet.prices.delete)
    },
    openModalPrices () {
      var that = this
      // set to default
      if (this.form.prices.length == 0) {
        this.autoGenSku = false
        this.replacePrice = false
        this.replaceCost = false
      }
      this.form.isShowModalPrices = true
      $('#pricesModal').modal('show')
    },
    closeModalPrices () {
      this.form.isShowModalPrices = false
      $('#pricesModal').modal('hide')
    },
    onChangedBrand () {

    },
    onChangedCat () {

    },
    onChangedUnit () {

    },
    handleFilePondInit: function () {

    },
    async process  (fieldName, file, metadata, load, error, progress, abort) {
      var that = this

      this.disabled.btn_update = true

      try {
        progress(true, 0, 1024)

        var formData = new FormData()
        formData.append(fieldName, file, file.name)
        formData.append('app_id', 2)
        formData.append('module_id', 1)

        let res = await that.$store.dispatch('uploadImage', formData)

        if (!res.success) {
          error(res.error)
        }

        res.data.map(img => {
          if (img.type == 'original') {
            that.form.images[0].location = img.location
          }
          if (img.type == 'thumbnail') {
            that.form.images[1].location = img.location
          }
        })

        load('success')

        this.disabled.btn_update = false

        return { abort: () => { abort() } }
      } catch (e) {
        return { abort: () => { abort() } }
      }
    },
    async revert (uniqueFileId, load, error) {
      this.checkToDeleteS3Images()

      this.disabled.btn_update = true
    },
    load (uniqueFileId, load, error) {
      error()
    },
    fetch (url, load, error, progress, abort, headers) {
      error('Solo archivos locales')
    },
    restore (uniqueFileId, load, error, progress, abort, headers) {
      error()
    },
    handleError (error, e) {

    },
    async checkToDeleteS3Images () {
      if (!this.form.images[0].location && !this.form.images[1].location) {
        return false
      }

      var dataSet = {
        'bucket': null,
        'objects': [],
      }

      this.form.images.map((img, idx) => {
        let bucket = this.getS3Bucket(img.location)
        let key = this.getS3Key(img.location)

        if (!dataSet.bucket) {
          dataSet.bucket = bucket
        }

        dataSet.objects.push({
          'key': key,
        })
      })

      let res = await this.$store.dispatch('deleteImage', dataSet)

      // set images location to null
      this.form.images[0].location = null
      this.form.images[1].location = null
    },
    setData () {
      let form = this.form
      let product = _.cloneDeep(this.product)

      form.typeRadios = product.type
      form.productName = product.product_name

      if (product.type == 'product') {
        if (this.product.prices.length == 1) {
          if (this.product.prices[0].price == null) {
            form.textField_ProductPrice = null
            form.isFixedPrice = false
          } else {
            form.textField_ProductPrice = this.product.prices[0].price == null ? null : this.setToCustomDigitsNumber(this.product.prices[0].price)
            form.isFixedPrice = true
          }
          form.textField_ProductCost = product.prices[0].cost == null ? null : this.setToCustomDigitsNumber(product.prices[0].cost)
          form.barcode = product.prices[0].barcode
          form.stock.sku = product.prices[0].sku_code
        } else if (this.product.prices.length > 1) {
          form.prices = this.genPrices(product.prices)
          form.defaultPrices = _.cloneDeep(form.prices)
          form.attributes = this.getDefaultAttributes(product)

          form.tempPrices = _.cloneDeep(form.prices)
          form.tempAttrs = _.cloneDeep(form.attributes)
        }
        if (product.images.original && product.images.thumbnail) {
          form.images[0].location = product.images.original
          form.images[1].location = product.images.thumbnail
        }
      } else if (product.type == 'service') {
        if (this.product.prices[0].price == null) {
          form.textField_ServicePrice = null
          form.isFixedPrice = false
        } else {
          form.textField_ServicePrice = this.product.prices[0].price == null ? null : this.setToCustomDigitsNumber(this.product.prices[0].price)
          form.isFixedPrice = true
        }
        form.textField_ServiceCost = product.prices[0].cost == null ? null : this.setToCustomDigitsNumber(product.prices[0].cost)
      }

      form.catName = product.category_name
      form.defaultCatName = product.category_name
      form.unit = product.unit
      form.defaultUnit = product.unit

      if (product.images.original == null) {
        form.isShowFilePond = true
      } else {
        form.isShowFilePond = false
      }

      // set form
      this.form = _.cloneDeep(form)

      // set originalForm
      this.originalForm = _.cloneDeep(form)
    },
    isFoundCustomSku (prices) {
      var foundSku = false
      prices.map(price => {
        if (price.sku_code !== null) {
          foundSku = true
        }
      })
      return !!foundSku
    },
    genPrices (prices) {
      let clonePrices = _.cloneDeep(prices)
      let newPrices = []
      clonePrices.map(price => {
        newPrices.push({
          'attributes': price.attributes,
          'sku': price.sku_code,
          'barcode': price.barcode,
          'price': price.price,
          'cost': price.cost,
          'is_available': price.is_available,
          'is_fixedprice': price.price != null,
          'is_custom_sku': this.isFoundCustomSku(prices),
        })
      })
      return newPrices
    },
    getPrices (newPrices, oldPrices) {
      let temp_oldPrices = _.cloneDeep(oldPrices)
      var resultPrices = []
      var newAttrInArray = []
      var oldAttrInArray = []

      newPrices.map(price => {
        var item = ''
        price.attributes.map(attribute => {
          item += attribute.name + '' + attribute.option
        })
        newAttrInArray.push(item)
      })
      oldPrices.map(price => {
        var item = ''
        price.attributes.map(attribute => {
          item += attribute.name + '' + attribute.option
        })
        oldAttrInArray.push(item)
      })

      newPrices.map(price => {
        var item = ''
        var result = null
        price.attributes.map((attribute, index) => {
          item += attribute.name + '' + attribute.option
        })
        if (oldAttrInArray.indexOf(item) >= 0) {
          let old = _.cloneDeep(this.getPriceByItem(item, oldPrices))
          result = _.cloneDeep(price)
          result['sku_id'] = old.sku_id
        } else {
          result = price
        }
        if (result) {
          resultPrices.push(result)
        }
      })

      return resultPrices
    },
    getPriceByItem (item, prices) {
      var result = null
      prices.find(price => {
        var _item = ''
        price.attributes.find(attribute => {
          _item += attribute.name + '' + attribute.option
        })
        if (item == _item) {
          result = _.cloneDeep(price)
        }
      })
      return result
    },
    getDeleteSkus (newPrices, oldPrices) {
      var resultIds = []
      var newSkuIds = []
      var oldSkuIds = []

      newPrices.map(price => {
        if (price.sku_id !== undefined) {
          newSkuIds.push(price.sku_id)
        }
      })
      oldPrices.map(price => {
        oldSkuIds.push(price.sku_id)
      })

      oldSkuIds.map(val => {
        if (newSkuIds.indexOf(val) === -1) {
          resultIds.push({
            'sku_id': val,
          })
        }
      })

      return resultIds
    },
    getInsertSkuds (skus) {
      var results = []
      skus.map(sku => {
        if (sku.sku_id === undefined) {
          results.push(sku)
        }
      })
      return results
    },
    getUpdateSkus (skus) {
      var results = []
      skus.map(sku => {
        if (sku.sku_id !== undefined) {
          results.push(sku)
        }
      })
      return results
    },
    getDefaultAttributes (product) {
      var skus = product.prices
      var currentAttribute = []
      var nameLists = null

      function getNextProductId (curIdx) {
        if (skus[curIdx + 1] === undefined) {
          return null
        }
        return skus[curIdx + 1].product_id
      }
      function getNameListsByProductId (productId) {
        var nameLists = []
        skus.map(sku => {
          if (sku.product_id == productId) {
            sku.attributes.map(attr => {
              if (nameLists.indexOf(attr.name) == -1) {
                nameLists.push(attr.name)
              }
            })
          }
        })
        return nameLists
      }

      skus.map((sku, index) => {
        var currentProductId = sku.product_id

        if (nameLists == null) {
          nameLists = getNameListsByProductId(currentProductId)
          nameLists.map(value => {
            currentAttribute.push({
              name: value,
              options: [],
            })
          })
        }

        sku.attributes.map(attr => {
          let foundAtIdx = nameLists.indexOf(attr.name)
          if (foundAtIdx >= 0) {
            let options = currentAttribute[foundAtIdx].options
            if (options.indexOf(attr.option) == -1) {
              options.push(attr.option)
            }
          }
        })
      })

      // return newArray
      return currentAttribute.length > 0 ? currentAttribute : []
    },
    openConfirmdeleteModal () {
      $('#confirmdeleteModal').modal('show')
    },
    closeConfirmdeleteModal () {
      $('#confirmdeleteModal').modal('hide')
    },
    async del () {
      let data = {
        product_id: this.product.product_id,
      }

      let res = await this.$store.dispatch('deleteProduct', data)

      if (res.success) {
        // show notify
        this.notify(this.$vs, {
          text: this.$t('message.hasbeendeleted', { msg: this.product.product_name }),
          color: 'danger',
          icon: 'delete',
        })
        // finish loading
        this.showFinish(this.$Progress)
        // close modal
        this.closeConfirmdeleteModal()
        // go to
        return this.$router.push({ name: 'ProductAll' })
      }
    },
    closeImage () {
      this.form.isShowFilePond = true
      this.form.images[0].location = null
      this.form.images[1].location = null
    },
    isDuplicatedProductName() {
      const productsNames = this.getNames.filter((name) => name !== this.product.product_name)
      return productsNames.includes(this.form.productName)
    },
  },
}
</script>

<style scoped>
  section.choose-type .form-check input, section.choose-type .form-check label {
    cursor: pointer;
  }
  section .form-check p {
    margin: 0;
  }
  .wrap-attributes-input .form-group {
    margin-bottom: 4px;
  }
  .wrap-attributes-input .form-group:last-of-type {
    margin-bottom: 0;
  }
  .wrap-attributes-input .inner-attribute-name {
    padding-right: 2px;
    z-index: 2;
  }
  .btn-close-image {
    margin-right: 5px;
    padding: 0;
    border-radius: 100%;
    height: 25px;
    width: 25px;
    background-color: rgba(0,0,0,.7);
    color: #fff;
  }
  .btn-close-image:hover {
    border: solid 2px #fff;
  }
  .btn-close-image i {
    font-size: 11px;
  }
  @media (max-width: 575.98px) {
    .choose-type .wrapper > div {
      margin-bottom: 15px;
    }
  }
  .min-width-label {
    min-width: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/components/apps/items/product/Edit.vue